// extracted by mini-css-extract-plugin
export default {"badges":"VolunteerBadges_badges__K3CyB","badge_new":"VolunteerBadges_badge_new__44XEx","badge_member":"VolunteerBadges_badge_member__ecX5a"};